import React, { createContext, useContext, useState } from 'react';

const TimeModeContext = createContext(null);
const TIME_MODE_KEY = 'trackwithtux_time_mode';

// Team-wide default is CST (where operations/leadership are based), even
// though people physically sit in different countries — with an opt-in
// toggle back to each person's own local timezone. Persisted like the
// sidebar collapse preference so it sticks across sessions.
export function TimeModeProvider({ children }) {
  const [mode, setModeRaw] = useState(() => localStorage.getItem(TIME_MODE_KEY) || 'cst');

  const setMode = (next) => {
    setModeRaw(next);
    localStorage.setItem(TIME_MODE_KEY, next);
  };

  const toggleMode = () => setMode(mode === 'cst' ? 'local' : 'cst');

  return (
    <TimeModeContext.Provider value={{ mode, setMode, toggleMode }}>
      {children}
    </TimeModeContext.Provider>
  );
}

export function useTimeMode() {
  const ctx = useContext(TimeModeContext);
  if (!ctx) throw new Error('useTimeMode must be used within a TimeModeProvider');
  return ctx;
}

// The timezone code every screen should actually display times in — CST by
// default, or the signed-in person's own timezone once they toggle to "local".
export function useDisplayTimezone(currentUser) {
  const { mode } = useTimeMode();
  return mode === 'cst' ? 'CST' : currentUser.timezone;
}
